export const DUMMY_RESIDENTS = [
  {
    id: "1",
    name: 'Arely Melton, "Arley"',
    room: "Room 412-B",
    mrn: "3728340",
    status: "In house",
    avatarLabel: "AM",
  },
  {
    id: "2",
    name: "Thompson, Gerald",
    room: "Room 101-A",
    mrn: "4819201",
    status: "In house",
    avatarLabel: "TG",
  },
  {
    id: "3",
    name: "Beaufort, Annelise",
    room: "Room 202-C",
    mrn: "5930482",
    status: "In house",
    avatarLabel: "BA",
  },
  {
    id: "4",
    name: "Kovaleski, Winston",
    room: "Room 305-D",
    mrn: "6041593",
    status: "In house",
    avatarLabel: "KW",
  },
  {
    id: "5",
    name: "Martinez, Sofia",
    room: "Room 210-B",
    mrn: "7152604",
    status: "In house",
    avatarLabel: "MS",
  },
];
